'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckPassword = function () {
  function CheckPassword() {
    _classCallCheck(this, CheckPassword);
  }

  _createClass(CheckPassword, null, [{
    key: 'Check',
    value: function Check(txt, rules) {
      if (rules !== undefined && rules !== null && (typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) === 'object' && txt !== undefined && txt !== null) {
        if (rules.length === 6) {
          var rule = {
            minLaenge: rules[0],
            countNumbers: rules[1],
            countLetters: rules[2],
            countLowerCaseLetters: rules[3],
            countUpperCaseLetters: rules[4],
            countSymbol: rules[5]
          };

          var valid = true;

          if (txt.length < rule.minLaenge) {
            return false;
          }

          var regExDigits = /[0-9]/g;
          var regExSymbols = /[^a-zA-ZäöüÄÖÜ0-9]/g;
          var regExChars = /[a-zA-ZäöüÄÖÜ]/g;
          var regExCharsLowerCase = /[a-zäöü]/g;
          var regExCharsUpperCase = /[A-ZÄÖÜ]/g;

          if (valid === true) {
            var validNumbers = true;
            var validLetters = true;
            var validLowerCaseLetters = true;
            var validUpperCaseLetters = true;
            var validSymbols = true;

            if (rule.countNumbers > 0) {
              validNumbers = this.atLeastTwo(txt, regExDigits, rule.countNumbers);
            }

            if (rule.countLetters > 0) {
              validLetters = this.atLeastTwo(txt, regExChars, rule.countLetters);
            }

            if (rule.countLowerCaseLetters > 0) {
              validLowerCaseLetters = this.atLeastTwo(txt, regExCharsLowerCase, rule.countLowerCaseLetters);
            }

            if (rule.countUpperCaseLetters > 0) {
              validUpperCaseLetters = this.atLeastTwo(txt, regExCharsUpperCase, rule.countUpperCaseLetters);
            }

            if (rule.countSymbol > 0) {
              validSymbols = this.atLeastTwo(txt, regExSymbols, rule.countSymbol);
            }

            if (validNumbers === true && validLetters === true && validLowerCaseLetters === true && validUpperCaseLetters === true && validSymbols === true) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    }
  }, {
    key: 'atLeastTwo',
    value: function atLeastTwo(txt, regEx, num) {
      var arr = txt.match(regEx);
      if (arr != null) {
        if (arr.length >= num) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }]);

  return CheckPassword;
}();

exports.default = CheckPassword;